import { Component, OnDestroy, OnInit } from '@angular/core';
import { catchError, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { AccountService } from 'src/app/shared/services/account.service';
import { DataService } from 'src/app/shared/services/data.service';
import { PositionService } from 'src/app/shared/services/position.service';
import { faRotate } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-position-search',
    templateUrl: './position-search.component.html',
    styleUrls: ['./position-search.component.scss'],
    standalone: false
})
export class PositionSearchComponent implements OnInit, OnDestroy {
    faRotate: any = faRotate;

    public groups: Array<any> = [];
    private onDestroy$ = new Subject<void>();
    public loading: boolean = false; // Added loading property
    public symbol: string = '';
    public group: string = '0';
    public side: string = '0';
    private riaId: number;

    constructor(private positionService: PositionService, private dataService: DataService,
        private accountService: AccountService) { }

    ngOnInit(): void {
        this.dataService.currentRiaId$
            .pipe(
                takeUntil(this.onDestroy$),
                tap(riaId => {
                    this.riaId = riaId; // Update riaId from the observable
                    this.loading = true;
                }),
                // switchMap(riaId => 
                //     this.positionService.getAllGroups(riaId)
                //         .pipe(
                //             catchError(error => {
                //                 console.error("Error fetching groups:", error);
                //                 return of([]); // Return an empty array on error
                //             })
                //         )
                // ),
                tap(() => this.loading = false) // Set loading to false after data fetch or error
            )
            .subscribe(() => this.onSearch());
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    public onReset() {
        this.group = "0";
        this.side = "0";
        this.symbol = "";
        this.onSearch();
    }

    public onSearch() {
        if (this.riaId) { // Ensure riaId is present before searching
            this.positionService.searchExecutedSubject.next({
                riaId: this.riaId,
                symbol: this.symbol,
                group: this.group,
                side: this.side
            });
        } else {
            console.error('No riaId available for search');
        }
    }
}
